import { MultiSelect } from './MultiSelect';
import type { ClientEditOption } from '@/api/clients';

/** Мультиселект «Кураторы» — MultiSelect со списком кураторов клиента. */
export function TutorsMultiSelect({
  tutorIds,
  tutors,
  disabled,
  onChange,
}: {
  tutorIds: number[];
  tutors: ClientEditOption[] | undefined;
  disabled: boolean;
  onChange: (ids: number[]) => void;
}) {
  return (
    <MultiSelect
      values={tutorIds}
      options={tutors}
      disabled={disabled}
      onChange={onChange}
      label="Кураторы"
      emptyText="Нет доступных кураторов"
    />
  );
}
